import TimestampAble    from '@widesk-core/models/traits/TimestampAble';
import ShopServiceModel from '@/models/ShopServiceModel';
import model            from '@widesk-core/decorators/model';
import doc              from '@widesk-core/decorators/doc';

@model.urnResource('service')
@doc.path('/stonecode_file_services/{?id}')
export default class ServiceModel extends TimestampAble(ShopServiceModel) {
	private declare _tsFilters: {
		'serviceUrn': string;
	};

	private declare _tsSorts: {
		'id': string;
		'updatedAt': string;
	};

	@doc.modelUrn(ServiceModel) declare service: ServiceModel;
}
